import axios from "axios";
import { Dispatch } from "redux";
import Url from "../../../Url";
import { AddCaseActionTypes } from "./ActionTypes";
import { AddCaseBody, AddCaseResponse } from "./Model";
import {
  addCaseAPIResClearAction,
  addCaseErrorAction,
  addCaseLoadingAction,
  addCaseSuccessAction,
  addCaseAPIMsgAction,
} from "./Action";
import { headers } from "../../../components/Utility";
import { setupInterceptorsTo } from "../../Authentication/Interceptors";

let apiRes = {} as AddCaseResponse;
export const addPatientCase = (payload: AddCaseBody) => {
  return function (dispatch: Dispatch<AddCaseActionTypes>) {
    dispatch(addCaseLoadingAction(true));
    setupInterceptorsTo(axios)
      .post(Url.baseUrl + `/patientapp/api/patient/add_patient_case`, payload, {
        headers: headers,
      })
      .then((res) => {
        apiRes = res.data;
        dispatch(addCaseLoadingAction(false));
        dispatch(
          addCaseSuccessAction(
            res.data,
            res.data.message !== undefined
              ? res.data.message
              : "Case added successfully"
          )
        );
      })
      .catch((error) => {
        dispatch(addCaseLoadingAction(false));
        dispatch(
          addCaseErrorAction(
            {} as AddCaseResponse,
            error.response.data !== undefined
              ? error.response.data.message !== undefined
                ? error.response.data.message
                : "Something went wrong"
              : "Something went wrong",
            error.status !== undefined ? error.response.data.status || 0 : 0
          )
        );
      });
  };
};

export const addCaseAPIResMsg = () => {
  return function (dispatch: Dispatch<AddCaseActionTypes>) {
    dispatch(addCaseAPIMsgAction(apiRes as AddCaseResponse, "", "", 0));
  };
};

export const clearAddCaseAPIRes = () => {
  return function (dispatch: Dispatch<AddCaseActionTypes>) {
    dispatch(addCaseAPIResClearAction({} as AddCaseResponse, "", "", 0));
  };
};
